import userAgentMixin from '@/mixins/userAgent';

export default {
  mixins: [
    userAgentMixin,
  ],
};



// WEBPACK FOOTER //
// ./src/components/pages/page-accessibility-statement/page-accessibility-statement.js